// UploadVersionComponent.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const UploadVersionComponent = () => {
  const [versions, setVersions] = useState([]);

  useEffect(() => {
    axios.get('/api/upload-versions/')
      .then(res => setVersions(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Dataset Versions</h2>
      <ul className="space-y-2">
        {versions.map(version => (
          <li key={version.version_id} className="border rounded p-2">
            {version.dataset_name} - v{version.version_number} <br />
            File: {version.file_path} <br />
            Uploaded at: {version.uploaded_at}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UploadVersionComponent;

